<template>
	<Draggable
		class="maku-draggable"
		:list="list"
		ghost-class="ghost"
		item-key="type"
		:group="{ name: 'item', pull: 'clone', put: false }"
		:sort="false"
		:clone="clone"
	>
		<template #item="{ element }">
			<div class="item">
				<ma-icon :icon="element.type || 'org'"></ma-icon>
				<span>{{ element.label }}</span>
			</div>
		</template>
	</Draggable>
</template>

<script lang="ts" setup>
import Draggable from 'vuedraggable'

defineProps({
	list: {
		type: Array,
		required: true
	}
})

const clone = (origin: any) => {
	return JSON.parse(JSON.stringify(origin))
}
</script>

<style lang="scss">
.widget-form-list {
	.ghost {
		content: '' !important;
		font-size: 0;
		outline-width: 0;
		height: 3px;
		box-sizing: border-box;
		border-top: red 3px solid !important;
		background-color: red !important;
		overflow: hidden;
	}
}
.maku-draggable {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;

	.ma-icon {
		font-size: 16px !important;
		display: inline-block;
		vertical-align: middle;
		margin-left: 4px;
		margin-right: 2px;
		width: 24px;
		text-align: center;
	}

	.item {
		width: 110px;
		font-size: 13px;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 28px;
		height: 28px;
		border-radius: 2px;
		color: #444;
		background-color: rgb(244, 246, 252);
		border: 1px solid #f4f6fc;
		margin: 2px 0;
	}

	.item:hover {
		color: rgb(102, 177, 255);
		border: 1px dashed rgb(102, 177, 255);
		cursor: move;
	}
}
</style>
